import instance from 'services/api';
import { USER_LOADED } from 'constants/user';
import { getCurrentBusiness, setLoading } from '../business';
import { filterBrands } from 'utils/convertLocationListForAsyncLoadOption';
import {
  ALL_BRANDS_OF_FILTER,
  ALL_BRANDS_WITHOUT_FILTER,
  COLLECT_BUSINESS_IDS_FOR_HISTORY,
  SET_ALL_BRAND,
  SET_LOCATION_FOR_BRANDS,
} from '../types';
import { extractIds } from 'utils/extractIds';

export const setBrandList = (brandList) => {
  return {
    type: 'SET_BRAND_LIST',
    payload: brandList,
  };
};

export const setSearchBrandList = (searchBrandList) => {
  return {
    type: 'SET_SEARCH_BRAND_LIST',
    payload: searchBrandList,
  };
};

export const setCurrentBrand = (currentSelectedBrand) => {
  return {
    type: 'SET_CURRENT_BRAND_MEV3',
    payload: currentSelectedBrand,
  };
};

export const setCurrentLocation = (currentSelectedLocation) => {
  return {
    type: 'SET_CURRENT_LOCATION',
    payload: currentSelectedLocation,
  };
};

export const setPaginationConfig = (paginationConfig) => {
  return {
    type: 'SET_PAGINATION_CONFIG',
    payload: paginationConfig,
  };
};

export const appendBrandList = (newBrands) => {
  return {
    type: 'APPEND_BRAND_LIST',
    payload: newBrands,
  };
};

export const appendSearchBrandList = (newBrands) => {
  return {
    type: 'APPEND_SEARCH_BRAND_LIST',
    payload: newBrands,
  };
};

const formatSelectedLocation = (currentSelectedLocation) => {
  return {
    classifications: currentSelectedLocation?.classifications,
    disabled: currentSelectedLocation?.disabled,
    label:
      currentSelectedLocation?.locationName || currentSelectedLocation?.label,
    name:
      currentSelectedLocation?.locationName || currentSelectedLocation?.name,
    value: {
      _id: currentSelectedLocation?._id,
      locationName: currentSelectedLocation?.locationName,
      businessId: currentSelectedLocation?.businessId,
      ...currentSelectedLocation?.value,
    },
    verified: currentSelectedLocation?.verified,
  };
};

const selectedBrandFormat = (currentSelectedBrand) => {
  return {
    id: currentSelectedBrand?._id,
    label: currentSelectedBrand?.brandName,
    name: currentSelectedBrand?.brandName,
    value: {
      _id: currentSelectedBrand?._id,
      brandName: currentSelectedBrand?.brandName,
      locations: currentSelectedBrand?.locations || [],
    },
  };
};

export const getAllBusinessesByLimit = (
  limit = 10,
  page = 1,
  search = '',
  verified = true,
  showLoading = true
) => {
  return async (dispatch) => {
    if (showLoading) {
      dispatch(setLoading(true));
    }
    dispatch({ type: 'SET_IS_BUSINESS_LOADING', payload: true });
    try {
      const isActive =
        localStorage.getItem('showActiveBusiness') === null
          ? true
          : Boolean(Number(localStorage.getItem('showActiveBusiness')));
      const userBusinessFromStorage = JSON.parse(
        localStorage.getItem('businessInfo')
      );
      if (localStorage.getItem('showActiveBusiness') === null) {
        localStorage.setItem('showActiveBusiness', 1);
      }
      const verifiedQuery = isActive ? 'yes' : 'no';
      const response = await instance.get(
        `/users/me-v3?search=${encodeURIComponent(
          search
        )}&limit=${limit}&page=${page}&verified=${verifiedQuery}`
      );
      const currentData = response?.data?.data || {};
      if (currentData?.user?.email) {
        localStorage.setItem('email', currentData?.user?.email);
      }
      if (userBusinessFromStorage) {
        dispatch(
          getCurrentBusiness(
            userBusinessFromStorage?.id,
            currentData?.user._id,
            currentData?.user?.plan
          )
        );
      } else {
        dispatch(
          getCurrentBusiness(
            currentData?.brands[0]?.locations[0]?.businessId,
            currentData?.user._id,
            currentData?.user?.plan
          )
        );
      }
      const currentSelectedBrand = selectedBrandFormat(currentData?.brands[0]);
      const currentSelectedLocation = formatSelectedLocation(
        currentData?.brands[0]?.locations[0]
      );
      localStorage.setItem(
        'selectedLocation',
        JSON.stringify(currentSelectedLocation)
      );
      localStorage.setItem(
        'selectedBrand',
        JSON.stringify(currentSelectedBrand)
      );
      dispatch({
        type: 'SET_ALL_BRANDS_AND_LOCATIONS_FOR_PAUSE_RESUME',
        payload: currentData?.brands || [],
      });
      dispatch(setCurrentBrand(currentData?.brands[0] || {}));
      dispatch(setBrandList(currentData?.brands || []));
      dispatch(setPaginationConfig(currentData?.pagination || {}));
      dispatch({ type: USER_LOADED, payload: { data: currentData.user } });
    } catch (error) {
      console.error('Error fetching businesses:', error);
      dispatch(setLoading(false));
    } finally {
      setTimeout(() => {
        dispatch(setLoading(false));
        dispatch({ type: 'SET_IS_BUSINESS_LOADING', payload: false });
      }, 1000);
    }
  };
};

export const getMoreBusinessesByLimit = (
  limit = 10,
  page = 1,
  search = '',
  verified = true
) => {
  return async (dispatch, getState) => {
    const { mev3 } = getState();
    const { brandList } = mev3;
    dispatch({ type: 'SET_FETCH_MORE_DATA_LOADING', payload: true });
    const verifiedQuery = verified ? 'yes' : 'no';
    try {
      const response = await instance.get(
        `/users/me-v3?search=${encodeURIComponent(
          search
        )}&limit=${limit}&page=${page}&verified=${verifiedQuery}`
      );
      const currentData = response?.data?.data || {};

      // For pagination, append new brands to existing list instead of replacing
      dispatch(appendBrandList(currentData?.brands || []));
      dispatch({
        type: 'SET_ALL_BRANDS_AND_LOCATIONS_FOR_PAUSE_RESUME',
        payload: [...brandList, ...currentData?.brands] || [],
      });
      dispatch(setPaginationConfig(currentData?.pagination || {}));
    } catch (error) {
      console.error('Error fetching businesses:', error);
      dispatch(setLoading(false));
    } finally {
      dispatch({ type: 'SET_FETCH_MORE_DATA_LOADING', payload: false });
    }
  };
};

export const searchBrandByLimit = (
  limit = 10,
  page = 1,
  search = '',
  loadMoreAction = false,
  verified = true
) => {
  return async (dispatch) => {
    if (loadMoreAction) {
      dispatch({ type: 'SET_FETCH_MORE_DATA_LOADING', payload: true });
    } else {
      dispatch({ type: 'SET_SEARCH_LOADING', payload: true });
    }
    const verifiedQuery = verified ? 'yes' : 'no';
    try {
      const response = await instance.get(
        `/users/me-v3?search=${encodeURIComponent(
          search
        )}&limit=${limit}&page=${page}&verified=${verifiedQuery}`
      );
      const currentData = response?.data?.data || {};
      if (loadMoreAction) {
        dispatch(appendSearchBrandList(currentData?.brands || []));
      } else {
        dispatch(setSearchBrandList(currentData?.brands || []));
      }
      dispatch({
        type: 'SET_PAGINATION_CONFIG_SEARCH_BRAND',
        payload: currentData?.pagination || {},
      });
    } catch (error) {
      console.error('Error fetching businesses:', error);
      dispatch(setLoading(false));
    } finally {
      dispatch({ type: 'SET_FETCH_MORE_DATA_LOADING', payload: false });
      dispatch({ type: 'SET_SEARCH_LOADING', payload: false });
    }
  };
};

export const getAllBrandsAndLocations = (limit = -1, page = 1) => {
  return async (dispatch) => {
    try {
      const response = await instance.get(
        `/users/me-v3?limit=${limit}&page=${page}`
      );
      const currentData = response?.data?.data || {};
      const ids = extractIds(currentData?.brands);
      dispatch({ type: COLLECT_BUSINESS_IDS_FOR_HISTORY, payload: ids || [] });
      dispatch({ type: SET_ALL_BRAND, payload: currentData?.brands || [] });
      dispatch({
        type: SET_LOCATION_FOR_BRANDS,
        payload: currentData?.brands || [],
      });
      dispatch({
        type: ALL_BRANDS_WITHOUT_FILTER,
        payload: currentData?.brands || [],
      });
      dispatch({
        type: ALL_BRANDS_OF_FILTER,
        payload: filterBrands(currentData?.brands) || [],
      });
    } catch (error) {
      console.error('Error fetching businesses:', error);
      dispatch(setLoading(false));
    } finally {
      dispatch({ type: 'SET_FETCH_MORE_DATA_LOADING', payload: false });
      dispatch({ type: 'SET_SEARCH_LOADING', payload: false });
    }
  };
};
